import React, {useEffect, useState} from 'react';
import './ChannelsPage.scss'
import {useDispatch, useSelector} from "react-redux";
import {GetChannels} from "../../../redux/actions";
import LayoutContainer from "../../../modules/Layout/Layout";
import {PlusNewIcon} from "../../../image";
import ChannelsList from "./components/ChannelsList/ChannelsList";
import {hasPermission, scrollTop} from "../../../utils/helperFunctions";
import {Loader} from "../../../shared/features/Loader";
import {useTranslation} from "react-i18next";
import ChannelForm from "../../../modules/Channel/ChannelForm/ChannelForm";
import {ROLE_ITEMS} from "../../../utils/constants";

const ChannelsPage = (props) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const isFullWidth = useSelector(state => state.utils.isFullWidth);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedChannelId, setSelectedChannel] = useState(null);

    const getChannels = async () => {
        try {
            setIsLoading(true);
            const channels = await dispatch(GetChannels());
            setSelectedChannel(channels.filter((item)=>!item?.is_private)?.[0]?.id)
            setIsLoading(false);
        }catch (e) {
            setIsLoading(false);
            console.error(e)
        }
    }

    useEffect(()=>{
        scrollTop();
        getChannels()
    },[]);

    return (
        <LayoutContainer isSearch title={t('menu_item_channels')}>
            <div className={`channels-wrap`}>
                <div className="channels-block">
                    <div className="channels-block__wrap">
                        <ChannelsList
                            selectedChannelId={selectedChannelId}
                            selectedChannel={setSelectedChannel}
                        />
                        {isLoading ?
                            <div className="channels-block__loader">
                                <Loader size={100}/>
                            </div>
                            :
                            <ChannelForm channelId={selectedChannelId} setSelectedChannel={setSelectedChannel}/>
                        }
                    </div>
                </div>
            </div>
        </LayoutContainer>
    );
};

export default ChannelsPage;